import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {MessageData} from '../../../RightBarController';
import './MessagesList.scss';

interface MessagesListProps {
    messages: MessageData[];
    isAsianLanguage: boolean;
    dir: 'ltr' | 'rtl';
    UserType: {client: string; agent: string};
    onClick?: () => void;
}

@observer
export class MessagesList extends TechseeBaseComponent<MessagesListProps> {
    private scrollContainerRef = React.createRef<HTMLDivElement>();

    componentDidMount(): void {
        this.scrollToBottom();
    }

    componentDidUpdate(prevProps: MessagesListProps): void {
        if (prevProps.messages.length !== this.props.messages.length) {
            this.scrollToBottom();
        }
    }

    private scrollToBottom = (): void => {
        if (this.scrollContainerRef.current) {
            this.scrollContainerRef.current.scrollTop = this.scrollContainerRef.current.scrollHeight;
        }
    };

    renderInternal(): JSX.Element {
        const {messages, isAsianLanguage, dir, UserType, onClick} = this.props;

        return (
            <div className='messages-scroll-container' ref={this.scrollContainerRef}>
                <ul className='text-center panel-body-sublist text-left panel-body-sublist-messages' onClick={onClick}>
                    {messages.map((text, index) => (
                        <li
                            key={index}
                            className={`panel-body-sublist-text ${
                                text.sender === UserType.client ? 'client-text' : ''
                            } ${text.isNew ? 'new-message' : ''}`}>
                            <span
                                className={`text-message-container ${dir === 'rtl' ? 'text-right' : ''} ${
                                    isAsianLanguage ? 'asian-language' : ''
                                }`}
                                dangerouslySetInnerHTML={{__html: text.message}}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}
